import React, { useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { SRow, SCol } from '@avalara/skylab-sdk/react';
import { format, addYears } from 'date-fns';
import { getReturnsSalesTax } from '../../lib/side-effects/avatax';
import { isFormIncomplete } from '../../lib/shared-signup';
import { selectState } from '../../selectors';
import { selectReturnsPricingData } from '../../selectors/returns';
import OrderSummaryHeader from '../offer/order-summary/order-summary-header';
import { OrderSummaryContainer, OrangeHorizontalRule, GreyTermsBox } from '../offer/styled/order-summary';
import { getOrderSummary } from '../../selectors/order';
import Discount from '../offer/order-summary/discount';
const OrderSummary = () => {
    const dispatch = useDispatch();
    const { account: { accountId }, order: { discountName, discountPercent, }, sharedSignup, } = useSelector(selectState);
    const { discountAmount, pricePerReturn, subtotalDisplayText, salestaxDisplayText, totalPrice, subtotal, } = useSelector(selectReturnsPricingData);
    const renewalDate = format(addYears(new Date(), 1), 'P');
    const { showDiscountedSubTotal } = useSelector(getOrderSummary);
    const isDiscountApplied = !!discountPercent && discountPercent > 0;
    const formIncomplete = isFormIncomplete(sharedSignup);
    useEffect(() => {
        dispatch(getReturnsSalesTax());
    }, [accountId, formIncomplete]);
    return (React.createElement(Fragment, null,
        React.createElement(OrderSummaryContainer, null,
            React.createElement(OrderSummaryHeader, null),
            React.createElement(SRow, { className: 'justify-content-end align-items-center order-summary-text pad-left-none pad-top-sm pad-bottom-xs space-between' },
                React.createElement(SCol, { span: '8' }, "Annual subscription"),
                React.createElement(SCol, { span: '4', className: `text-right ${isDiscountApplied ? ' text-strikethrough' : ''}` },
                    React.createElement("span", null, subtotalDisplayText))),
            isDiscountApplied &&
                React.createElement(Discount, { currency: 'USD', discountAmount: discountAmount, discountName: discountName, showDiscountedSubTotal: showDiscountedSubTotal, subtotal: subtotal }),
            React.createElement(SRow, { className: 'justify-content-end align-items-center order-summary-text pad-left-none pad-top-xs pad-bottom-xs space-between' },
                React.createElement(SCol, { span: '6' }, "Sales tax"),
                React.createElement(SCol, { span: '6', className: `text-right${/calculated/i.test(salestaxDisplayText) ? ' font-italic text-sm' : ''}` },
                    React.createElement("span", null, salestaxDisplayText))),
            React.createElement(SRow, { className: 'justify-content-end order-summary-text pad-bottom-sm pad-left-none pad-top-xs space-between' },
                React.createElement(SCol, { span: '8' },
                    React.createElement("span", null,
                        "e-filing fee",
                        React.createElement("p", { className: 'font-italic smaller-text' }, 'per return as incurred'))),
                React.createElement(SCol, { span: '4', className: 'text-right' },
                    React.createElement("span", null, pricePerReturn))),
            React.createElement(OrangeHorizontalRule, { className: 'margin-left-xs margin-right-xs' }),
            React.createElement(SRow, { className: 'justify-content-end align-items-center order-summary-text pad-top-sm pad-left-none pad-bottom-none' },
                React.createElement(SCol, { span: '8' },
                    React.createElement("span", null, "Total due today")),
                React.createElement(SCol, { span: '4', className: 'text-right' },
                    React.createElement("span", null, totalPrice))),
            React.createElement(SRow, null,
                React.createElement(GreyTermsBox, null,
                    React.createElement("p", { className: 'text-sm' }, "BILLING TERMS"),
                    React.createElement("p", { className: 'pad-top-xs small-height small-text' },
                        "Automatic renewal billed to your payment method on",
                        ' ',
                        React.createElement("span", null, renewalDate)),
                    React.createElement("p", { className: 'pad-bottom-xs small-text' }, "Filing fees will be applied as incurred"))))));
};
export default OrderSummary;
